module.exports = __webpack_public_path__ + "src/assets/img/inear_en.a4a1ea50.png";